import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import React from "react";

interface Props {
  data: any;
  open: boolean;
  onClose?: () => void;
}

const KvkkModal: React.FC<Props> = ({ data, open, onClose }) => {
  const [openModal, setOpen] = React.useState(open);
  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={openModal} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{data?.title}</DialogTitle>
        </DialogHeader>
        <div dangerouslySetInnerHTML={{ __html: data?.content }} className="overflow-y-auto max-h-[500px]" />
      </DialogContent>
    </Dialog>
  );
};

export default KvkkModal;
